import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import regroupements from './modules/regroupements/regroupements'
import articlesFilter from './modules/articlesFilter/articlesFilter'
import planVente from './modules/planVente/planVente'
import modal from './modules/modal/modal'
import routing from './modules/routing/routing'
import forfaitsTransport from './modules/forfaitsTransport/forfaitsTransport'
import typeForfaitTransport from './modules/typeForfaitTransport/typeForfaitTransport'
import selectionModeles from './modules/selectionModeles/selection-modeles'
import dimensionsVariables from './modules/dimensionsVariables/dimensionsVariables'
import unite from './modules/unite/unite'
import statistiques from './modules/statistiques/statistiques'
import agence from './modules/agence/agence'
import importation from './modules/importation/importation'
import commandes from './modules/commandes/commandes'
import clients from './modules/clients/clients'
import transporteurs from './modules/transporteurs/transporteurs'

const plugins = process.env.NODE_ENV === 'development'
  ? [createLogger()]
  : []

const store = new Vuex.Store({
    plugins,
    modules: {
        articlesFilter,
        planVente,
        modal,
        regroupements,
        routing,
        forfaitsTransport,
        typeForfaitTransport,
        selectionModeles,
        dimensionsVariables,
        unite,
        statistiques,
        agence,
        importation,
        commandes,
        clients,
        transporteurs
    }
})
export default store
